
export const selectTodayAppointmentsList = (state) => state.appointmentsList.todayAppointemts;
export const selectUpComingAppointmentsList = (state) => state.appointmentsList.upcomingAppointemts;
export const selectPastAppointmentsList = (state) => state.appointmentsList.pastAppointemts;
export const selectLoading = (state) => state.appointmentsList.loading;
